<article class="detail-layout">
    <h1 class="overview-title" translate="Core.InternalServerError.Title"></h1>
    <div class="highlight">
        <div class="highlight__inner">
            <div>
                <h3 translate="Core.ErrorPage.Subtitle"></h3>
                <p translate="Core.ErrorPage.Manieren"></p>
                <ul class="icon-list">
                    <li>
                        <i class="icon-home" aria-hidden="true"></i>
                        <span translate="Core.ErrorPage.Terugkeren"></span>
                        <a [href]="'Core.Crumbs.Lez.Url' | translate" translate="Core.ErrorPage.TerugkerenDoel"></a>
                    </li>
                    <li>
                        <i class="icon-fancyback" aria-hidden="true"></i>
                        <span translate="Core.ErrorPage.BrowserTerug"></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</article>